import styled from "styled-components/macro";

export const SalonDetails = styled.div<{ direction: string; fontSize?: string }>`
  direction: ${({ direction }) => direction};
  margin-bottom: 10px;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : "20px")};
`;
